import FinancialTableBodyHeader from './FinancialTableBodyHeader';

export default FinancialTableBodyHeader;
